import React, { useRef, useState } from 'react';
import { Label } from '@/components/ui/label';

// Draggable focal point on the mobile image, with immediate crop preview.
export default function FocalPointEditor({ imageUrl, focusX = 50, focusY = 50, onChange }) {
  const containerRef = useRef(null);
  const [dragging, setDragging] = useState(false);

  const setFromEvent = (e) => {
    const rect = containerRef.current.getBoundingClientRect();
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;
    const x = Math.round(Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100)));
    const y = Math.round(Math.max(0, Math.min(100, ((clientY - rect.top) / rect.height) * 100)));
    onChange(x, y);
  };

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
      <div>
        <Label className="text-xs text-[#7a7a7a]">Trascina il punto focale ({focusX}% {focusY}%)</Label>
        <div
          ref={containerRef}
          className="relative mt-1 cursor-crosshair select-none overflow-hidden rounded"
          onMouseDown={(e) => { setDragging(true); setFromEvent(e); }}
          onMouseMove={(e) => dragging && setFromEvent(e)}
          onMouseUp={() => setDragging(false)}
          onMouseLeave={() => setDragging(false)}
          onTouchStart={(e) => { setDragging(true); setFromEvent(e); }}
          onTouchMove={(e) => dragging && setFromEvent(e)}
          onTouchEnd={() => setDragging(false)}
        >
          <img src={imageUrl} alt="Punto focale" className="w-full" draggable={false} />
          <div
            className="pointer-events-none absolute h-6 w-6 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-white shadow-[0_0_0_2px_rgba(0,0,0,0.5)]"
            style={{ left: `${focusX}%`, top: `${focusY}%` }}
          />
        </div>
      </div>
      <div>
        <Label className="text-xs text-[#7a7a7a]">Anteprima ritaglio mobile (copertine)</Label>
        <div className="mt-1 aspect-[9/16] max-h-64 overflow-hidden rounded bg-[#f0f0f0]">
          <img
            src={imageUrl}
            alt="Anteprima punto focale"
            className="h-full w-full object-cover"
            style={{ objectPosition: `${focusX}% ${focusY}%` }}
          />
        </div>
      </div>
    </div>
  );
}